module.exports = __webpack_public_path__ + "img/profviews.2d2415c4.svg";